import { useRef } from "react";

export default function usePreMount(fn, condition) {
    const firstRender = useRef(true);

    if (firstRender.current) {
        firstRender.current = false;
        if (condition) {
            fn();
        }
    }
}